import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory, withRouter} from 'react-router-dom';
import {RTLProps} from '@/shared/prop-types/ReducerProps';
import {Modal, ModalBody, Row, Col, ListGroup, ListGroupItem, Card, CardBody, Button, Tab, TabPane} from 'reactstrap';
import CloseButton from "@/shared/components/CloseButton";
import CreatableSelect from "react-select/creatable";
import axios from "axios";
import {useDispatch, flashSuccess, flashError, sendFlashMessage} from "@/shared/components/flash";
import Dropzone from 'react-dropzone-uploader'
import 'react-dropzone-uploader/dist/styles.css'
import {isEmpty} from '@/shared/helpers'
import {Field, Form} from "react-final-form";
import TrashIcon from 'mdi-react/TrashOutlineIcon';
import { SortableContainer, SortableElement, arrayMove } from "react-sortable-hoc";
import DeleteMediaTypeModal from "@/containers/Program/View/components/DeleteMediaTypeModal"
import HierarchySaveDigitalMediaModal from './HierarchySaveDigitalMediaModal';
import HierarchyListDigitalMediaModal from './HierarchyListDigitalMediaModal';
import HierarchyResultDigitalMediaModal from './HierarchyResultDigitalMediaModal';
import RemoveHierarchyModal from '@/containers/Program/View/components/event/RemoveHierarchyModal';
import RemovalHierarchyDigitalMediaModal from './RemovalHierarchyDigitalMediaModal';
import DeletedResultHierarchyDigitalMediaModal from './DeletedResultHierarchyDigitalMediaModal';
//import ScriptTag from 'react-script-tag';
// import {formatBytes, formatDuration} from "react-dropzone-uploader/dist/utils";

const fileTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/msexcel',
  'application/x-msexcel',
  'application/x-ms-excel',
  'application/x-excel',
  'application/x-dos_ms_excel',
  'application/xls',
  'application/x-xls',
  'application/x-msi',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/xml',
  'application/xml',
  'text/html',
  'application/rtf',
  'text/csv',
  'application/x-afp',
  'image/*',
  'audio/*',
  'video/*',
];

const SortableItem = SortableElement(({ file, index, handleRemoveFile }) => (
  <div className="dropzone__img" key={file.name} style={{
    border: '1px solid grey',
    width: `125px`,
    backgroundImage: `url("${process.env.REACT_APP_API_STORAGE_URL + '/' + file.icon_path}")`
  }}>
    <p className="dropzone__img-name">{file.name}</p>
    <button className="dropzone__img-delete" type="button"  onClick={() => handleRemoveFile(file)} >
      Remove
    </button>
  </div>
));

const SortableList = SortableContainer(({ media, handleRemoveFile }) => {
  return (
    <div className="dropzone__imgs-wrapper">
      {media.map((file, index) => (
        <SortableItem key={file.name} index={index} file={file} handleRemoveFile={handleRemoveFile}/>
      ))}
    </div>
  );
});

const DigitalMediaModal = ({organization, isOpen, setOpen, toggle, program, theme, rtl}) => {
  const [trigger, setTrigger] = useState(0);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const [media, setMedia] = useState([]);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [mediaType, setMediaType] = useState('');
  const [currentMedia, setCurrentMedia] = useState(null);
  const [uploadedMeta, setUploadedMeta] = useState({});
  const [iconMeta, setIconMeta] = useState({});
  const [fileName, setFileName] = React.useState("");
  let [dropZoneKey, setDropZoneKey] = useState(0);
  const [tab, setTab] = useState(1);
  const [link, setLink] = useState("");
  const [tempLink, setTempLink] = useState()
  const [openInNewTab, setOpenInNewTab] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [currentMenuItem, setCurrentMenuItem] = useState();
  const [currentForm, setCurrentForm] = useState(null);
  const MAX_SIZE = 10485760
  const [uploadError, setUploadError] = useState({})
  const [delCategory, setDelCategory] = useState(null)
  const [isDeleteCategoryOpen, setDeleteCategoryOpen] = useState(false);
  const [isOpenHierarchy, setOpenHierarchy] = useState(false);
  const [isOpenHierarchyList, setOpenHierarchyList] = useState(false);
  const [hierarchyListData, setHierarchyListData] = useState([]);
  const [checkedState, setCheckedState] = useState([]);
  const [isOpenHierarchyResult, setOpenHierarchyResult] = useState(false);
  const [hierarchyListDataResult, setHierarchyListDataResult] = useState([]);
  const [isDeleteHierarchy, setDeleteHierarchy] = useState(false);
  const [isDeleteHierarchyList, setDeleteHierarchyList] = useState(false);
  const [deletedHierarchyData, setDeletedHierarchyData] = useState([]);
  const [isDeleteHierarchyResult, setDeleteHierarchyResult] = useState(false);
  const [deleteHierarchyListDataResult, setDeleteHierarchyListDataResult] = useState([]);
  const [file, setFile] = React.useState(null);


  const handleSortEnd = ({ oldIndex, newIndex }) => {
    setMedia((prevMedia) => arrayMove(prevMedia, oldIndex, newIndex));
  };

  const loadMediTypes = async () => {
    try {
      let response = await axios.get(`/organization/${organization.id}/program/${program.id}/digital-media-type`);
      if (response.data.length === 0) response.data = []; 
      let options = [];
      let menuItems = [];
      response.data.map(row => {
        if (row.is_menu_item === 1) {
          menuItems.push({
            value: row.program_media_type_id,
            url: row.menu_link,
            id: row.program_media_type_id,
            menu_link:row.menu_link,
            open_in_new_tab: Number(row.open_in_new_tab) === 1,
            label: row.name
          })
        }
        else {
          options.push({
            value: row.program_media_type_id,
            label: row.name
          });
         
        }
      })
      setMediaTypes(options);
      setMenuItems(menuItems);      
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  }

  const handleChangeMedia = (value) =>{
    if(value){
      setCurrentMedia(value)
      getData(value.value)
    }
    else{
      setCurrentMedia(null)
      setMedia([])
    }
  }

  const handleChangeForms = (form) =>{
    if(form){
      setCurrentForm(form)
      getIframe(form.value)
    }
    else{
      setCurrentForm(null)
      setTempLink(null)
      setLink('')
      setOpenInNewTab(false)
    }
  }
  
  const getData = async (media_type) => {

    const url = axios.defaults.baseURL + `/organization/${organization.id}/program/${program.id}/media/${media_type}`;

    try {
      const response = await axios.get(url);

      const data = response.data;
      setMediaType(media_type);
      setMedia(data);
  
      return data;
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
    
  }

  const getIframe = (value) => {    
    let temp = menuItems.filter(iframe =>  iframe.id === value)[0];    
    setCurrentMenuItem(temp); 
    setLink(temp.menu_link || "")
    setTempLink(temp.menu_link || null);
    setOpenInNewTab(!!temp.open_in_new_tab);
    getData(temp.id);
  }

  useEffect(() => {
    loadMediTypes();
  }, []);

  const toggleHierarchy = (values) => {
    setOpenHierarchy(prevState => !prevState)
  }
  const toggleHierarchyList = () => {
    setOpenHierarchyList(prevState => !prevState)
  }
  const toggleHierarchyResult = () => {
    setOpenHierarchyResult(prevState => !prevState)
  }
  const toggleDeleteHierarchy = () => {
    setDeleteHierarchy(prevState => !prevState)
  }
  const toggleDeleteHierarchyList = () => {
    setDeleteHierarchyList((prevState) => !prevState);
  };
  const toggleDeleteHierarchyResult = () => {
    setDeleteHierarchyResult(prevState => !prevState)
  }
  let history = useHistory();

  const getUploadParams = ({meta}) => {
    
    const headers = {
      'Authorization': axios.defaults.headers.common['Authorization'],
    }
    const fields = {'fileId': meta.id}
    return {
      url: axios.defaults.baseURL + `/organization/${organization.id}/program/${program.id}/digital-media/upload`,
      headers,
      fields
    }
  }

  const onDeleteHierarchy = async () => {
    try {
      const mediaId = tab == '1' ? currentMedia.value : currentMenuItem.id;
      const url = tab == '1' && file?.id ? `/organization/${organization.id}/program/${program.id}/programMedia/${file?.id}/digital-media-type/${mediaId}/prepare-media-delete-hierarchy` : `/organization/${organization.id}/program/${program.id}/digital-media-type/${mediaId}/prepare-delete-hierarchy`;

      const response = await axios.get(url);

      if (response.status === 200) {
        const responseData = response.data;

        // Populate hierarchy table
        setDeletedHierarchyData(responseData);

        // Initialize checkbox state
        setCheckedState(
          responseData.map(row => ({
            value: row.media_type_id,
            checked: true
          }))
        );

        toggleDeleteHierarchy();
        toggleDeleteHierarchyList();
      }
    } catch (error) {
      console.error(error);
      dispatch(
        sendFlashMessage(
          "Error deleting hierarchy",
          "alert-danger"
        )
      );
    }
  };

  const onSubmitDeleteHierarchyList = () => {
    const mediaData = {};
    const mediaIds = checkedState
      .filter((item) => item.checked)
      .map((item) => item.value);
    mediaData.media_ids = mediaIds;
    const mediaId = tab == '1' ? currentMedia.value : currentMenuItem.id;

    axios
      .delete(
        `/organization/${organization.id}/program/${program.id}/digital-media-type/${mediaId}/delete-hierarchy-digital-media`,
        {
          data: mediaData,
        }
      )
      .then((res) => {
        if (res.status === 200) {
          const list = res.data.deleted_data;
          setDeleteHierarchyListDataResult(list);
          loadMediTypes();
          setCurrentForm(null);
          setCurrentMedia(null);
          setTempLink(null);
          flashSuccess(dispatch, "Media(s) deleted successfully!");
          toggleDeleteHierarchyResult();
          toggleDeleteHierarchyList();
        }
      })
      .catch((err) => {
        flashError(
          dispatch,
          err.response?.data || "Failed to fetch delete list"
        );
        setLoading(false);
        toggleDeleteHierarchyResult();
      });
  };

  const handleRemoveFile = (file) => {
    if (file) {
      setFile(file)
      toggleDeleteHierarchy();
    }
  }

  const removeFile = () => {

    const response = axios.delete(
        `/organization/${organization.id}/program/${program.id}/programMedia/${file.id}/digital-media`
    );

    const items = media.filter(item => item.id != file.id);
    setMedia(items);
    toggleDeleteHierarchy();
  };

  useEffect(() => {
    if (isDeleted) {
      loadMediTypes();
      setCurrentMedia(null);
      setIsDeleted(false);
    }
  }, [isDeleted]);

  const onSubmitHierarchy = async () => {
    try {
      const url =tab == '1' ? `/organization/${organization.id}/program/${program.id}/digital-media-type/${currentMedia.value}/prepare-media-hierarchy` : `/organization/${organization.id}/program/${program.id}/digital-media-type/${currentMenuItem.id}/prepare-hierarchy`;
      const res = await axios.get(url);
      const responseData = res.data;
      // Set hierarchy table data
      setHierarchyListData(responseData);

      // Set checkbox states (one per program)
      setCheckedState(
        responseData.map(row => ({
          value: row.id,
          checked: true
        }))
      );
      setOpenHierarchy(false);
      setOpenHierarchyList(true);

    } catch (error) {
      console.error(error);
      dispatch(
        sendFlashMessage("Error preparing hierarchy list", "alert-danger")
      );
    }
  };

  const onSubmitHierarchyList = async () => {
    try {
      // Get selected program IDs
      const programsToCopy = checkedState
        .filter(item => item.checked)
        .map(item => item.value);

      if (programsToCopy.length === 0) {
        dispatch(sendFlashMessage("Please select at least one program", "alert-danger"));
        return;
      }
      let data;
      if (tab == '1') {
        data = new FormData();
        data.append('file', JSON.stringify(uploadedMeta))
        data.append('icon', JSON.stringify(iconMeta))
        data.append('name', fileName)
        data.append('mediaType', mediaType)
        data.append('programs_to_copy', JSON.stringify(programsToCopy))
        data.append('program_media_type_id', currentMedia.value)
        data.append('_method', 'PUT');
      } else {
        data = {
          programs_to_copy: programsToCopy,
          program_media_type_id: currentMenuItem.id
        }
      }
      const url = tab == '1' ? `/organization/${organization.id}/program/${program.id}/digital-media-type/${currentMedia.value}/update-media-hierarchy` : `/organization/${organization.id}/program/${program.id}/digital-media-type/${currentMenuItem.id}/update-hierarchy-digital-media`;

      const res = await axios.post(url, data);
      if (res.status === 200 && tab == '1') {
        getData(mediaType);
        setUploadedMeta({})
        setIconMeta({})
        setFileName('');
        dropZoneKey++;
        setDropZoneKey(dropZoneKey);
      }

      setHierarchyListDataResult(res.data);

      toggleHierarchyList();
      toggleHierarchyResult();

    } catch (error) {
      console.error(error);
      dispatch(sendFlashMessage("Error updating hierarchy", "alert-danger"));
    }
  };

  const onSubmit = () => {
    let saveUrl = `/organization/${organization.id}/program/${program.id}/digital-media`;
    setLoading(true);
    let data = new FormData();
    data.append('file', JSON.stringify(uploadedMeta))
    data.append('icon', JSON.stringify(iconMeta))
    data.append('name', fileName)
    data.append('mediaType', mediaType)

    axios.post(saveUrl, data)
      .then((res) => {
        if (res.status === 200) {
            getData(mediaType);
            setUploadedMeta({})
            setIconMeta({})
            setFileName('');
            dropZoneKey++;
            setDropZoneKey( dropZoneKey );
          setTrigger(Math.floor(Date.now() / 1000))
          flashSuccess(dispatch, "Media successfully published!!")
        }
        setLoading(false)
      })
      .catch(error => {
        console.log(JSON.stringify(error.response.data.errors));
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setLoading(false)
        throw new Error(`API error:${error?.message}`);
      })
  }

  const saveLinkForIframe = (newLink, newTab = openInNewTab) => {
    let saveUrl = axios.defaults.baseURL +  `/organization/${organization.id}/program/${program.id}/digital-media-type-iframe`;
    let data = new FormData();
    setLoading(true)
    data.append('program_media_type_id', currentMenuItem.id)
    if(newLink){
      data.append('menu_link', newLink);
    }
    // removing the link also clears "open in new tab"
    data.append('open_in_new_tab', newLink && newTab ? 1 : 0);

    axios.post(saveUrl, data)
      .then((res) => {
        if (res.status === 200) {
          let menuItem = {
            value: res.data.program_media_type_id,
            url: res.data.menu_link,
            id: res.data.program_media_type_id,
            menu_link:res.data.menu_link,
            open_in_new_tab: Number(res.data.open_in_new_tab) === 1,
            label: res.data.name
          }
          setCurrentMenuItem(menuItem)
          loadMediTypes();
          if(!res.data.menu_link){
            setTempLink(null)
            setLink("")
            setOpenInNewTab(false)
          }
        }
        setLoading(false)
      })
      .catch(error => {
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setLoading(false)
        throw new Error(`API error:${error?.message}`);
      });
  }

  const selectCreateIframe = (inputValue) => {

    setIsLoading(true);
    let saveUrl = axios.defaults.baseURL +  `/organization/${organization.id}/program/${program.id}/digital-media-type`;

    let data = new FormData();
    data.append('name', inputValue);
    data.append('is_menu_item', 1);
    
    axios.post(saveUrl, data)
      .then((res) => {
        // console.log(res)
        if (res.status === 200) {
          setCurrentForm({
            value: res.data.program_media_type_id,
            label: res.data.name
          })
          let newMenuItem = {
            value: res.data.program_media_type_id,
            url: res.data.menu_link,
            id: res.data.program_media_type_id,
            menu_link:res.data.menu_link,
            label: res.data.name
          }
          setCurrentMenuItem(newMenuItem)
          setLink('')
          setTempLink(null)
          setOpenInNewTab(false)
          loadMediTypes();
        }
        setIsLoading(false)
      })
      .catch(error => {
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setIsLoading(false)
        throw new Error(`API error:${error?.message}`);
      });
  }

  const validate = values => {    
    let errors = {}
    if (!currentMedia){
      errors.category = 'The category field is required.';
    }
    if (isEmpty(iconMeta)){
      errors.icon_upload = 'The preview image field is required.';
    }
    if (isEmpty(uploadedMeta)){
      // setUploadError(prevError => ({ ...prevError, file: null }));
      errors.media_upload = 'The file field is required.';
    }
    if (!fileName){
      errors.fileName = 'The file name field is required.';
    }
    return errors
  }

  const modalProps = {
    isOpen, toggle, setOpen
  }

  const handleChangeStatus = ({meta, file}, status) => {
    
    if (status === 'done') {
      let name = meta.name.substr(0, meta.name.lastIndexOf('.'));
      if (!fileName || fileName !== name) {
        setFileName(name);
      }
      setUploadedMeta(meta);
      setUploadError(prevError => ({ ...prevError, file: null }));
    }
    if (status === "error_file_size"){
      setUploadError(prevError => ({ ...prevError, file: "File is too big" }));
    }
    if(status == 'removed'){
      setFileName('');
      setUploadedMeta({});
      setUploadError(prevError => ({ ...prevError, file: null }));
    }
    if(status === 'error_upload'){
      setUploadError(prevError => ({ ...prevError, file: "Upload error" }));
    }
  }

  const handleUploadIcon = ({meta, file}, status) => {
    if (status === 'done') {
      setIconMeta(meta);
      setUploadError(prevError => ({ ...prevError, icon: null }));
    }
    if (status === "error_file_size"){
      setUploadError(prevError => ({ ...prevError, icon: "File is too big" }));
    }
    if(status == 'removed'){
      setIconMeta({});
      setUploadError(prevError => ({ ...prevError, icon: null }));
    }
    if(status === 'error_upload'){
      setUploadError(prevError => ({ ...prevError, icon: "Upload error" }));
    }
  }

  const onChangeFileName = (event) => {
    setFileName(event.target.value);
  }

  const onChangeLinkUrl = (event) => {
    setLink(event.target.value)
  }

  const selectCreateOption = (inputValue) => {
  
    let saveUrl = axios.defaults.baseURL +  `/organization/${organization.id}/program/${program.id}/digital-media-type`;

    let data = new FormData();
    data.append('name', inputValue);
    data.append('is_menu_item', 0);
    
    axios.post(saveUrl, data)
      .then((res) => {        
        if (res.status === 200) {
          loadMediTypes();
          setMedia([]);
          setMediaType(res.data.program_media_type_id)
          setCurrentMedia({
            value: res.data.program_media_type_id,
            label: res.data.name
          })
        }
        setIsLoading(false)
      })
      .catch(error => {
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setIsLoading(false)
        throw new Error(`API error:${error?.message}`);
      });
  }

  const addMenus = () => {
    if (link !== "") {      
      setTempLink(link); 
      saveLinkForIframe(link);
    }
  
  }

  const deleteMenu = (remove) =>{
    const mediaId= tab == '1' ? currentMedia.value : currentMenuItem.id;
    axios.delete(
      `/organization/${organization.id}/program/${program.id}/digital-media-type/${mediaId}`
    ).then((res) => { 
      if (res.status === 200) {
        loadMediTypes();
        setCurrentForm(null)
        setCurrentMedia(null)
        setTempLink(null)
        setTrigger(Math.floor(Date.now() / 1000))
        flashSuccess(dispatch, "Media Category Deleted SuccessFully!!")   
        toggleDeleteHierarchy();
      }
    })
    .catch(error => {
      console.log(error)
      console.log(JSON.stringify(error.response.data.errors));
      dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
      setLoading(false)
      throw new Error(`API error:${error?.message}`);
    });    
  }

  const deleteMediaAttachmentsHierarchy = () => {
    const mediaData = {};
    const mediaIds = checkedState
      .filter((item) => item.checked)
      .map((item) => item.value);
    mediaData.media_ids = mediaIds;
    const mediaId = tab == '1' ? currentMedia.value : currentMenuItem.id;

    axios.delete(
      `/organization/${organization.id}/program/${program.id}/digital-media-type/${mediaId}/delete-media-hierarchy`, {
      data: mediaData,
    }
    ).then((res) => {
      if (res.status === 200) {

        const list = res.data.deleted_data;
        setDeleteHierarchyListDataResult(list);
        const items = media.filter(item => item.id != file.id);
        setMedia(items);
        setTrigger(Math.floor(Date.now() / 1000))
        flashSuccess(dispatch, "Media Attachments Deleted SuccessFully!!")
        toggleDeleteHierarchyResult();
        toggleDeleteHierarchyList();
      }
    })
      .catch(error => {
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'))
        setLoading(false)
        throw new Error(`API error:${error?.message}`);
      });
  }

  const setMediaTab = () => {
    if(tab !== 1){
      setTempLink(null)
      setLink('')
      setTab(1);
      setUploadError({});
      setCurrentForm(null)
    }
  }

  const setFormsTab = () => {
    if(tab !== 2){
      setMedia([])
      setTab(2);
      setCurrentMedia(null)
      setFileName('')
      setIconMeta({})
      setUploadedMeta({})
    }
  }

  function toTitleCase(str) {
    return str.toLowerCase().replace(/(?:^|\s)\w/g, function(match) {
      return match.toUpperCase();
    })
  }

  const updatePosition = () => {
    const updatedMedia = media.map((file, index) => ({
        ...file,
        position: index + 1
    }));

    console.log('Updated media:', updatedMedia);

    let updateUrl = `/organization/${organization.id}/program/${program.id}/update-digital-media-position`;
    setLoading(true);

    axios.post(updateUrl, {media: updatedMedia})
      .then((res) => {
        if (res.status === 200) {
            dispatch(sendFlashMessage('Media successfully updated', 'alert-success'));
        }
        setLoading(false);
      })
      .catch(error => {
        console.log(JSON.stringify(error.response.data.errors));
        dispatch(sendFlashMessage(JSON.stringify(error.response.data.errors), 'alert-danger'));
        setLoading(false);
        throw new Error(`API error:${error?.message}`);
      });
  }
  const toggleDeleteCategory = () => {
    setDeleteCategoryOpen(prevState => !prevState)
}
  const onClickDeletePopup = () => {
    setDelCategory({ currentMedia });
    toggleDeleteCategory()
  }
  return (
    <Modal className={`modal-program modal-lg`} {...modalProps}>
      <CloseButton onClick={toggle}/>
      <ModalBody className='modal-lg'>
        <Card>
          <CardBody className='pt-0'>
              {tab === 1 ?
                <Form
                  onSubmit={() => {}}
                  validate={validate}
                  render={({handleSubmit, form, submitting, pristine, values}) => (
                    <form className="form" onSubmit={handleSubmit}>

                      <Row>
                        <Col md="12" lg="12" xl="12">
                          <div className="card__title">
                            <h3>Upload Digital Media</h3>
                            <h5 className="colorgrey">{program.name}</h5>
                            <div style={{paddingTop: '25px', paddingBottom:'25px'}}>
                              <Button  color="primary" className="mr-3" onClick={setMediaTab}>media</Button>
                              <Button  color="primary" className="mr-3" onClick={setFormsTab}>forms</Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                            <div>
                              <Field name="category">
                                {({ input, meta }) => (
                                  <div className="form__form-group">
                                    <div className="form__form-group-field">
                                      <div className="form__form-group-row" style={{position: '', marginTop: '0px', textTransform:"capitalize", zIndex: 100}}>
                                        <CreatableSelect
                                          name="category"
                                          isClearable
                                          isDisabled={isLoading}
                                          isLoading={isLoading}
                                          options={mediaTypes}
                                          onCreateOption={selectCreateOption}
                                          placeholder='Select or Create a Menu Category'
                                          onChange={ handleChangeMedia }
                                          value={currentMedia}
                                        />
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Field>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <Field name="icon_upload">
                            {({input, meta}) => (
                              <div className="form__form-group">
                                <div className="form__form-group-field  flex-column" style={{position: '', marginTop: '0px'}}>
                                  <Dropzone key={dropZoneKey}
                                    getUploadParams={getUploadParams}
                                    accept="image/jpeg, image/png, image/gif"
                                    // accept="image/*,audio/*,video/*"
                                    name="icon_upload"
                                    inputContent="Select Preview Image"
                                    maxFiles={1}
                                    maxSizeBytes ={MAX_SIZE}    
                                    onSubmit={false}
                                    onChangeStatus={handleUploadIcon}
                                  />
                                  {meta.touched && meta.error && !uploadError.icon && <span className="form__form-group-error">{meta.error}</span>}
                                  {uploadError && uploadError.icon && <p className="form__form-group-error">{ uploadError.icon }</p>}
                                </div>
                              </div>
                              )}
                          </Field>
                        </Col>
                        <Col md="4">
                          <Field name='media_upload'>
                            {({input, meta}) => (
                              <div className="form__form-group">
                                <div className="form__form-group-field  flex-column" style={{position: '', marginTop: '0px'}}>
                                  <Dropzone key={dropZoneKey}
                                    getUploadParams={getUploadParams}
                                    accept={fileTypes.join(',')}
                                    name="media_upload"
                                    inputContent="Select File"
                                    maxFiles={1}
                                    onSubmit={false}
                                    maxSizeBytes ={MAX_SIZE}
                                    onChangeStatus={handleChangeStatus}
                                  />
                                </div>
                                {meta.touched && meta.error && !uploadError.file && <span className="form__form-group-error">{meta.error}</span>}
                                {uploadError && uploadError.file && <p className="form__form-group-error">{ uploadError.file }</p>}
                              </div>
                            )}
                          </Field>
                        </Col>
         
                        <Col md="4">
                          <div>
                            <Field name="fileName">
                              {({input, meta}) => (
                                <div className="form__form-group">
                                  <span className="form__form-group-label">Enter File Name </span>
                                  <div>
                                    <input onChange={onChangeFileName}
                                          name='fileName'
                                          style={{borderWidth: 1, borderColor: 'gray'}}
                                          type="text" value={fileName}
                                          placeholder="File Name"/>
                                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                  </div>
                                </div>
                              )}
                            </Field>
                          </div>
                          {currentMedia && <div>
                          <Button className="btn btn-danger" onClick={toggleDeleteHierarchy} 
                                    color="#ffffff">Delete category</Button>
                          </div>}
                        </Col>
                      </Row>
                      {delCategory && <DeleteMediaTypeModal isOpen={isDeleteCategoryOpen} setOpen={setDeleteCategoryOpen} toggle={toggleDeleteCategory} program={program} category = {currentMedia} setTrigger={setTrigger} setIsDeleted={setIsDeleted}/>}
                      <Row>
                        <Col>
                          <div>
                            <Button type="submit" disabled={loading || !currentMedia || !fileName || !iconMeta} onClick={toggleHierarchy} className="btn btn-primary"
                                    color="#ffffff">Save</Button>
                          </div>
                        </Col>
                      </Row>

                    </form>
                  )}
                />
                 :                 
                  <>
                      <Row>
                        <Col md="12" lg="12" xl="12">
                          <div className="card__title">
                            <h3>Upload Digital Media</h3>
                            <h5 className="colorgrey">{program.name}</h5>
                            <div style={{paddingTop: '25px', paddingBottom:'25px'}}>
                              <Button  color="primary" className="mr-3" onClick={setMediaTab}>media</Button>
                              <Button  color="primary" className="mr-3" onClick={setFormsTab}>forms</Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <div className="form__form-group">
                            <div className="form__form-group-field  flex-column" style={{position: '', marginTop: '0px', textTransform:"capitalize"}}>
                              <CreatableSelect
                                  name="category"
                                  isClearable
                                  isDisabled={isLoading}
                                  isLoading={isLoading}
                                  options={menuItems}
                                  onCreateOption={selectCreateIframe}
                                  placeholder='Select or Create a Menu Category'
                                  onChange={ handleChangeForms }
                                  value={ currentForm }
                                />

                            </div>
                          </div>
                          { currentForm && 
                          <div className="form__form-group">
                            <span className="form__form-group-label">Link </span>
                              <div className='table-filter-form form row'>
                                <div className='col-sm-4 col-md-4 col-lg-4'>
                                  <input onChange={onChangeLinkUrl}
                                      style={{borderWidth: 1, borderColor: 'gray', maxWidth:'200px'}}
                                      type="text" value={link}
                                      placeholder="Link Url"/>
                                </div>
                                <div className='col-sm-4 col-md-4 col-lg-4 d-flex justify-content-end'>      
                                  <Button  color="primary" disabled={!link || link === tempLink} className="" onClick={()=>addMenus()}>{!tempLink ? "Add" : "Update"}</Button>
                                </div>
                                <div className='col-sm-4 col-md-4 col-lg-4 d-flex justify-content-end'>      
                                  <div className="pointer" onClick={toggleDeleteHierarchy}>
                                    <TrashIcon color='#777777' />
                                  </div>
                                </div>
                              </div>
                              <label className="d-flex align-items-center mt-2" style={{gap: '8px', cursor: 'pointer'}}>
                                <input type="checkbox" checked={openInNewTab} disabled={loading}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setOpenInNewTab(checked);
                                    // a saved link is updated right away, like Add/Update
                                    if (currentMenuItem?.menu_link) saveLinkForIframe(currentMenuItem.menu_link, checked);
                                  }} />
                                <span>Open in a new tab</span>
                                <small className="text-muted">(for sites that can't be shown inside the rewards site, e.g. cort.com)</small>
                              </label>
                          </div>
                          }
                        </Col>
                      </Row>
                      { tempLink && 
                        <Row>
                          <Col md="12">
                            <div className='form__form-group'>
                              <div className='table-filter-form form row'>
                                  <div className='col-sm-8 col-md-8 col-lg-8'>
                                      <h4>{tempLink}</h4>
                                  </div>
                                  <div className='col-4 d-flex justify-content-end'>      
                                    <Button  color="primary" disabled={!currentMenuItem?.menu_link} className="" onClick={()=> { if(window.confirm('Are you sure to remove this link from the menu?')){saveLinkForIframe()}} }>Remove</Button>
                                  </div>
                                </div>
                            </div>
                          </Col>
                        </Row>
                      }
                      <Row>
                        <Col>
                          <div>
                            <Button onClick={toggleHierarchy} disabled={loading || !currentMenuItem} className="btn btn-primary"
                                    color="#ffffff">Save</Button>
                          </div>
                        </Col>
                      </Row>
                  </>
              }
              <Row>
                <Col>
                  {media && media.length > 0
                    && (
                      <>
                      <SortableList media={media} handleRemoveFile={handleRemoveFile} onSortEnd={handleSortEnd} axis="xy" />
                      <Col>
                        <div>
                          <Button onClick={updatePosition} disabled={loading} className="btn btn-primary" color="#ffffff">Update Positions</Button>
                        </div>
                      </Col>
                      </>
                    )}
                </Col>
              </Row>
          </CardBody>
        </Card>
        <HierarchySaveDigitalMediaModal
          isOpen={isOpenHierarchy}
          toggle={toggleHierarchy}
          tab={tab}
          onSubmit={onSubmit}
          onSubmitHierarchy={onSubmitHierarchy}
        />
        <HierarchyListDigitalMediaModal
          isOpen={isOpenHierarchyList}
          toggle={toggleHierarchyList}
          hierarchyListData={hierarchyListData}
          checkedState={checkedState}
          setCheckedState={setCheckedState}
          onSubmitHierarchyList={onSubmitHierarchyList}
          program={program}
        />
        <HierarchyResultDigitalMediaModal
          isOpen={isOpenHierarchyResult}
          toggle={toggleHierarchyResult}
          hierarchyListDataResult={hierarchyListDataResult}
        />
        <RemoveHierarchyModal
          isDeleteHierarchy={isDeleteHierarchy}
          toggleDeleteHierarchy={toggleDeleteHierarchy}
          onClickDeleteEvent={file ? removeFile : deleteMenu}
          onDeleteHierarchy={onDeleteHierarchy}
        />
        <RemovalHierarchyDigitalMediaModal
          isOpen={isDeleteHierarchyList}
          toggle={toggleDeleteHierarchyList}
          deletedHierarchyData={deletedHierarchyData}
          checkedState={checkedState}
          setCheckedState={setCheckedState}
          onSubmitDeleteHierarchyList={file ? deleteMediaAttachmentsHierarchy  :onSubmitDeleteHierarchyList }
        />
        <DeletedResultHierarchyDigitalMediaModal
          isDeleteHierarchyResult={isDeleteHierarchyResult}
          toggleDeleteHierarchyResult={toggleDeleteHierarchyResult}
          deleteHierarchyListDataResult={deleteHierarchyListDataResult}
          program={program}
          history={history}
        />
      </ModalBody>
    </Modal>
  )
}

const RenderImage = ({src}) => {
  if (!src || typeof src === 'undefined') return ''
  return (
    <div className='dropzone-img'>
      <a href={src} target='_blank' title='View the picture'>
        <img style={{maxHeight: 200}} src={src}/>
      </a>
    </div>
  )
}

DigitalMediaModal.propTypes = {
  rtl: RTLProps.isRequired,
  organization: Object.isRequired,
  data: Object.isRequired
};

export default withRouter(connect((state) => ({
  rtl: state.rtl,
  organization: state.organization,
  program: state.program
}))(DigitalMediaModal));
